import React, { useState } from 'react'
import Previous from '../../../src/static/images/previous.png'
import Next from '../../../src/static/images/next.png'
import { HeartlandServices } from '../../data/services';

function ServiceScroller() {

    const [currentIndex, setCurrentIndex] = useState(0);

    const nextService = () => {
        if (currentIndex < HeartlandServices.length - 1) {
            setCurrentIndex(currentIndex + 1);
            return;
        }
        setCurrentIndex(0);
    };

    const previousService = () => {
        if (currentIndex > 0) {
            setCurrentIndex(currentIndex - 1);
            return;
        }
        setCurrentIndex(0);
    };

  return (
    <div className='w-full flex md:flex-row justify-center items-center h-auto text-white font-bold text-xl sm:text-5xl' style={{ backgroundColor: 'rgba(7,59,76)' }}>
            <div className='p-2 md:p-4 bg-red-900 cursor-pointer' 
                onClick={previousService}
            >
                <img className="inline max-w-xs max-h-10 sm:max-h-12 md:max-h-16 md:max-w-md transition-transform duration-300 hover:scale-110" src={Previous} alt="Previous" /> 
            </div>

            <div className='w-full'>
                <div className="grid grid-cols-1 md:grid-cols-[20%_80%] gap-4 w-full h-full">
                    <div className="bg-white text-teal-900 sm:text-3xl p-4 flex text-center h-full font-extrabold">
                        {HeartlandServices[currentIndex].service}
                    </div>
                    <div className="p-4 text-justify sm:text-2xl flex items-center h-full">
                        {HeartlandServices[currentIndex].content} 
                    </div>
                </div>
            </div>
            
            <div className='p-2 md:p-4 bg-red-900 cursor-pointer' 
                onClick={nextService}
            >
                <img className="inline max-w-xs max-h-10 sm:max-h-12 md:max-h-16 md:max-w-md transition-transform duration-300 hover:scale-110" src={Next} alt="Next" /> 
            </div>
        </div>
  )
}

export default ServiceScroller
